/** Canonical diet product routes — import everywhere instead of string literals. */
export const DIET_ROUTES = {
  RECIPES_LIST: '/diet/recipes',
  RECIPES_NEW: '/diet/recipes/new',
  RECIPES_DETAIL: '/diet/recipes/:id',
  /** Admin reference data (meal types, nutrients, cuisines, etc.) */
  DIET_REFERENCE_DATA: '/diet/reference-data',
  TEMPLATES_LIST: '/diet/templates',
  TEMPLATES_NEW: '/diet/templates/new',
  TEMPLATES_DETAIL: '/diet/templates/:id',
  PLANS_EDITOR: '/diet/plans',
};

/** Route table for diet product pages (paths only — wired in routes.jsx). */
export const DIET_ROUTE_CONFIG = [
  { path: DIET_ROUTES.RECIPES_LIST, isPrivate: true },
  { path: DIET_ROUTES.RECIPES_NEW, isPrivate: true },
  { path: DIET_ROUTES.RECIPES_DETAIL, isPrivate: true },
  { path: DIET_ROUTES.DIET_REFERENCE_DATA, isPrivate: true },
  { path: DIET_ROUTES.TEMPLATES_LIST, isPrivate: true },
  { path: DIET_ROUTES.TEMPLATES_NEW, isPrivate: true },
  { path: DIET_ROUTES.TEMPLATES_DETAIL, isPrivate: true },
  { path: DIET_ROUTES.PLANS_EDITOR, isPrivate: false },
];

/** Build a concrete path from a route pattern and params. */
export function dietRoute(pathPattern, params = {}) {
  let path = pathPattern;
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, encodeURIComponent(String(value)));
  });
  return path;
}

export function recipeDetailPath(id) {
  return `/diet/recipes/${id}`;
}

export function templateDetailPath(id) {
  return `/diet/templates/${id}`;
}
